<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>卡片权重配置</span>
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="激活修正系数配置" name="first">
            <el-table
              :data="formData"
              border
              style="width: 70%"
            >
              <el-table-column
                prop="num"
                label="未激活卡数"
              >
                <template slot-scope="scope">
                  <el-input v-model="scope.row.num" placeholder="未激活卡数" />
                </template>
              </el-table-column>
              <el-table-column
                prop="coefficient1"
                label="激活修正系数"
              >
                <template slot-scope="scope">
                  <el-input v-model="scope.row.coefficient1" placeholder="激活修正系数" />
                </template>
              </el-table-column>
              <el-table-column
                prop="coefficient2"
                label="未激活修正系数"
              >
                <template slot-scope="scope">
                  <el-input v-model="scope.row.coefficient2" placeholder="未激活修正系数" />
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="数量修正系数" name="second">
            <el-table
              :data="formCofficientData"
              border
              style="width: 70%"
            >
              <el-table-column
                prop="num"
                label="卡片数"
              >
                <template slot-scope="scope">
                  <el-input v-model="scope.row.num" placeholder="卡片数" />
                </template>
              </el-table-column>
              <el-table-column
                prop="coefficient"
                label="激活修正系数"
              >
                <template slot-scope="scope">
                  <el-input v-model="scope.row.coefficient" placeholder="激活修正系数" />
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <el-button v-permisaction="['config:card-coefficient:add']" size="mini" type="primary" @click="onSubmit('second')">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCardCoefficient, updateCardCoefficientList } from '@/api/config/card-pro'
export default {
  name: 'CardCoefficient',
  data() {
    return {
      activeName: 'first',
      formData: [
        {
          'num': 0,
          'coefficient1': 0,
          'coefficient2': 0
        }
      ],
      formCofficientData: [
        {
          'num': 0,
          'coefficient': 0
        }
      ]
    }
  },
  created() {
    this.getTables('first')
  },
  methods: {
    onSubmit(tableName) {
      let data = []
      if (tableName === 'second') {
        data = JSON.stringify(this.formCofficientData)
      } else {
        this.formData.forEach((item) => {
          data.push({
            num: item.num,
            coefficient: item.coefficient1 + ',' + item.coefficient2
          })
        })
        data = JSON.stringify(data)
      }
      updateCardCoefficientList({ data: data, name: tableName }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(tableName) {
      getCardCoefficient({ name: tableName }).then(res => {
        if (tableName === 'second') {
          this.formCofficientData = []
          this.formCofficientData = res.data
        } else {
          this.formData = []
          res.data.forEach(item => {
            const [coefficient1, coefficient2] = item.coefficient.split(',')
            this.formData.push({
              num: item.num,
              coefficient1: coefficient1,
              coefficient2: coefficient2
            })
          })
        }
      })
    },
    handleClick(tab, event) {
      const tableName = tab.name
      this.getTables(tableName)
    }
  }
}
</script>

<style scoped>
</style>
